import type { ApolloCache, ApolloClient } from '@apollo/client';

import { ListUsersDocument } from '../__generated__/graphql/api';
import { getUserRefetchQuery } from '../components/UserDetails/getUserRefetchQuery';
import { invalidateApolloFields } from './apolloCacheInvalidation';

const USERS_LIST_QUERY_NAME = 'listUsers';

const invalidateUsersList = (cache: ApolloCache<unknown>) => {
  invalidateApolloFields(cache, [USERS_LIST_QUERY_NAME]);
};

export const getUsersListMutationRefreshOptions = () => ({
  refetchQueries: [ListUsersDocument],
  awaitRefetchQueries: true,
  update: invalidateUsersList,
});

export const getOnboardMutationRefreshOptions = () => ({
  refetchQueries: 'active' as const,
  awaitRefetchQueries: true,
});

export const getUserMutationRefreshOptions = (userId: string) => {
  const userRefetchQuery = getUserRefetchQuery(userId);

  return {
    ...userRefetchQuery,
    refetchQueries: [...userRefetchQuery.refetchQueries, ListUsersDocument],
    awaitRefetchQueries: true,
    update: invalidateUsersList,
  };
};

/** @public */
export const refreshUserAfterRestMutation = (apolloClient: ApolloClient<object>, userId: string) => {
  const userRefetchQuery = getUserRefetchQuery(userId);

  return apolloClient.refetchQueries({
    include: [...userRefetchQuery.refetchQueries.map(({ query }) => query), ListUsersDocument],
    updateCache: invalidateUsersList,
  });
};
